'use client';

import { User } from 'lucide-react';
import { PosterCard } from '@/components/PosterCard';

interface UserCardProps {
  user: {
    uid: string;
    username: string;
    displayName?: string;
    photoURL?: string | null;
  };
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export function UserCard({ user, size = 'medium', className = '' }: UserCardProps) {
  return (
    <PosterCard
      href={`/profile/${user.username}`}
      imageUrl={user.photoURL}
      title={user.displayName || user.username}
      subtitle={`@${user.username}`}
      placeholderIcon={<User className="h-16 w-16 text-gray-500" />}
      size={size}
      className={className}
    />
  );
}
